import React from 'react';
import { SEGMENTS } from './constants';

const Field = ({ label, children }) => (
  <label className="block">
    <span className="block text-sm font-semibold mb-2 text-white/85">{label}</span>
    {children}
  </label>
);

const maskPhone = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

export const RaioXFields = ({ step, form, set }) => {
  if (step === 0) return (
    <>
      <h3 className="text-2xl font-semibold">Vamos começar por você.</h3>
      <Field label="Seu nome"><input className="br-input" value={form.name} onChange={set('name')} placeholder="Como posso te chamar?" data-testid="raio-x-name" autoComplete="name" /></Field>
      <Field label="Seu WhatsApp"><input className="br-input" inputMode="tel" value={form.whatsapp} onChange={(e) => set('whatsapp')({ target: { value: maskPhone(e.target.value) } })} placeholder="(45) 99999-9999" data-testid="raio-x-whatsapp" autoComplete="tel" /></Field>
    </>
  );
  if (step === 1) return (
    <>
      <h3 className="text-2xl font-semibold">Agora, a sua empresa.</h3>
      <Field label="Nome da empresa"><input className="br-input" value={form.company} onChange={set('company')} placeholder="Ex.: Hotel Cataratas" data-testid="raio-x-company" /></Field>
      <Field label="@ do Instagram"><input className="br-input" value={form.instagram} onChange={set('instagram')} placeholder="@suaempresa" data-testid="raio-x-instagram" autoCapitalize="none" /></Field>
      <Field label="Segmento">
        <select className="br-input" value={form.segment} onChange={set('segment')} data-testid="raio-x-segment">
          <option value="" disabled>Selecione</option>
          {SEGMENTS.map((s) => <option key={s} value={s} className="bg-[#11171E]">{s}</option>)}
        </select>
      </Field>
    </>
  );
  return (
    <>
      <h3 className="text-2xl font-semibold">O que você quer conquistar?</h3>
      <Field label="Seu principal objetivo">
        <textarea className="br-input min-h-[150px] resize-none" value={form.goal} onChange={set('goal')} placeholder="Ex.: atrair clientes que valorizam qualidade, parar de competir por preço, lotar a baixa temporada..." data-testid="raio-x-goal" maxLength={500} />
      </Field>
    </>
  );
};
